import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import Track from "./components/Track";
import Rank from "./components/Rank";
import Pack from "./components/Pack";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-[#FFF9F1] text-stone-900">
      <TopNav />
      <main>
        <Hero />
        <Feed />
        <Track />
        <Rank />
        <Pack />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}